import React from "react";

const StepIcon = ({ state, inProgressLabel }) => {
  if (state === "complete") {
    return (
      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cfPrimaryButton">
        <svg
          viewBox="0 0 16 16"
          className="h-3 w-3 text-white"
          fill="none"
          stroke="currentColor"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 8.5l3 3 7-7" />
        </svg>
      </span>
    );
  }
  if (state === "current") {
    return (
      <span
        role="status"
        aria-label={inProgressLabel}
        className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-indigo-600 border-t-transparent animate-spin"
      />
    );
  }
  return (
    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-gray-300" />
  );
};

export default StepIcon;
